import React from 'react';

const DefaultFilterValues = Object.freeze({
    coverKey: 0,
    locKey: 0,
    acctKey: 0,
    covers: [],
    locations: [],
    providers: []
});

class ClFiltersContextObject {
    _clients = {
        valuesUpdated: {},
        filtersChanged: {}
    };
    _values = {...DefaultFilterValues};

    get Values() {
        return {...this._values, text: this.Text};
    }

    get Text() {
        const coverKey = this._values.coverKey;
        const locKey = this._values.locKey;
        const acctKey = this._values.acctKey;

        const c = this._values.covers.find(x=>x.coverKey==coverKey);
        const l = this._values.locations.find(x=>x.locKey==locKey);
        const p = this._values.providers.find(x=>x.acctKey==acctKey);
        
        const cover = `${coverKey}: ${c?.orgName ?? "[No OrgName]"}`;
        const location = `${locKey}: ${l?.orgName ?? "[No OrgName]"}`;
        const _p = (`${p?.firstName ?? ""} ${p?.lastName ?? ""}`).trim();
        const provider = `${acctKey}: ${_p ? _p : "[No Name]"}`;

        return locKey==0 && acctKey==0 ? `all locations and providers under cover "${cover}"` : 
                    acctKey==0 ? `all providers under location "${location}"` : 
                    locKey==0 ? `all locations having provider "${provider}"` : 
                    `provider "${provider}", under location "${location}"`;    
    }

    ClearProviders() {
        this.SetValues({acctKey: 0, v5Migration: DefaultFilterValues.v5Migration});
        this.UpdateClients_FiltersChanged("provider");
    }

    SetValues(value) {
        this._values = {...this._values, ...value};
        this.UpdateClients_ValuesUpdated();
    }

    UpdateClients_ValuesUpdated() {
        Object.values(this._clients.valuesUpdated).forEach(x => {
            x(this._values);
        });
    };

    UpdateClients_FiltersChanged(source) {
        Object.values(this._clients.filtersChanged).forEach(x => {
            x(this._values, source);
        });
    };

    Subscribe_ValuesUpdated(componentId, delegate) {
        if (delegate) this._clients.valuesUpdated[componentId] = delegate;
    }

    Subscribe_FiltersChanged(componentId, delegate) {
        if (delegate) this._clients.filtersChanged[componentId] = delegate;
    }

    UnSubscribe_ValuesUpdated(componentId) {
        if (this._clients.valuesUpdated[componentId]) {
            delete this._clients.valuesUpdated[componentId];
        }
    }

    UnSubscribe_FiltersChanged(componentId) {
        if (this._clients.filtersChanged[componentId]) {
            delete this._clients.filtersChanged[componentId];
        }
    }
}

const FiltersContext = React.createContext(new ClFiltersContextObject())
export default FiltersContext;